import { render, staticRenderFns } from "./sales-table.vue?vue&type=template&id=0e231216&scoped=true&"
import script from "./sales-table.vue?vue&type=script&lang=js&"
export * from "./sales-table.vue?vue&type=script&lang=js&"
import style0 from "./sales-table.vue?vue&type=style&index=0&id=0e231216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e231216",
  null
  
)

export default component.exports